export const PUBLIC_API_FEATURES = {
  moduleKey: 'public-api',
  features: ['public-api.api-keys', 'public-api.webhooks'] as const,
  featureMeta: {
    'public-api.api-keys': {
      name: 'API keys',
      translations: { name: { de: 'API-Schlüssel', en: 'API keys', fr: 'Clés API', it: 'Chiavi API' } },
    },
    'public-api.webhooks': {
      name: 'Webhooks',
      translations: { name: { de: 'Webhooks', en: 'Webhooks', fr: 'Webhooks', it: 'Webhook' } },
    },
  },
} as const;
